export const MESSAGING_PATHS = [
  "/scheduler",
  "/extend-guest-stay",
  "/alerts",
  "/surveys",
  "/saved-responses",
  "/message-templates",
];

export const OPERATIONS_PATHS = [
  "/operations",
  "/work-orders",
  "/work-schedules",
  "/availability-calendar",
];

export const GUEST_GUIDE_PATHS = [
  "/guide-designer",
  "/properties",
  "/extras",
  "/areas",
  "/areas_detail",
  "/property-field-values",
  "/subscriptions",
];

export const matchesSidebarPath = (pathname, paths, { exact = false } = {}) => {
  const candidates = Array.isArray(paths) ? paths : [paths];

  return candidates.some((path) =>
    exact ? pathname === path : pathname === path || pathname.startsWith(`${path}/`),
  );
};

export const getActiveSidebarMenu = (pathname) => {
  if (matchesSidebarPath(pathname, MESSAGING_PATHS)) return "messaging";
  if (matchesSidebarPath(pathname, OPERATIONS_PATHS)) return "operations";
  if (matchesSidebarPath(pathname, GUEST_GUIDE_PATHS)) return "guides";
  return null;
};

export const toggleSidebarMenu = (currentMenu, targetMenu) =>
  currentMenu === targetMenu ? null : targetMenu;
